import AddIcon from '@mui/icons-material/Add'
import EditIcon from '@mui/icons-material/Edit'
import FavoriteIcon from '@mui/icons-material/Favorite'
import { Button, Tooltip } from '@mui/material'

// Mirrors the vitals presence check used by the calendar strip (StepsCheckUI).
export function hasVitalsRecorded(bookedSlot) {
  return Boolean(
    bookedSlot?.vital ||
      bookedSlot?.vitals ||
      bookedSlot?.vitalData ||
      (Array.isArray(bookedSlot?.vitals) && bookedSlot.vitals.length > 0) ||
      (bookedSlot?.vital && Object.keys(bookedSlot.vital).length > 0),
  )
}

/**
 * Add/Edit vitals affordance for an Appointments row. Opens the same vitals
 * dialog the calendar strip uses. Always available (unlike the calendar's
 * StepsCheckUI, which only offers "Record Vitals" in the clinic-assistant portal).
 */
export default function ConsultsVitalsCell({ bookedSlot, onOpenVitals }) {
  if (!onOpenVitals) {
    return null
  }

  const hasVitals = hasVitalsRecorded(bookedSlot)

  if (hasVitals) {
    return (
      <Tooltip title="Edit vitals" arrow>
        <div
          role="button"
          tabIndex={0}
          onClick={() => onOpenVitals(bookedSlot)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '4px',
            cursor: 'pointer',
            padding: '2px 6px',
            borderRadius: '6px',
            fontSize: '12px',
            color: '#047857',
            backgroundColor: 'rgba(16, 185, 129, 0.1)',
            border: '1px solid rgba(16, 185, 129, 0.25)',
            whiteSpace: 'nowrap',
          }}
        >
          <FavoriteIcon style={{ color: '#ef4444', fontSize: '15px', flexShrink: 0 }} />
          <span>Vitals</span>
          <EditIcon style={{ color: '#666', fontSize: '13px', flexShrink: 0 }} />
        </div>
      </Tooltip>
    )
  }

  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={() => onOpenVitals(bookedSlot)}
      sx={{
        fontSize: '11px',
        padding: '2px 8px',
        minWidth: 'auto',
        height: '26px',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        borderColor: '#ef4444',
        color: '#ef4444',
        '&:hover': {
          borderColor: '#dc2626',
          backgroundColor: 'rgba(239, 68, 68, 0.08)',
        },
      }}
    >
      Add Vitals
    </Button>
  )
}
